// Hero Video Blur on Scroll - Apple Liquid Glass Level
(function () {
    'use strict';

    // Only run on homepage
    if (!document.body.classList.contains('template-index')) return;

    // Wait for DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        const hero = document.querySelector('.hero');
        const heroMedia = hero ? hero.querySelector('.hero__media-wrapper, .hero__media, video, .hero__background') : null;

        if (!hero || !heroMedia) return;

        let ticking = false;

        function updateBlur() {
            const scrolled = window.pageYOffset;

            // Instant blur - Apple liquid glass level (0-20px blur)
            // Blur increases as user scrolls, max at 20px for glass effect
            const blurValue = Math.min(scrolled / 25, 20);

            heroMedia.style.filter = `blur(${blurValue}px)`;
            heroMedia.style.webkitFilter = `blur(${blurValue}px)`;

            ticking = false;
        }

        function onScroll() {
            if (!ticking) {
                window.requestAnimationFrame(updateBlur);
                ticking = true;
            }
        }

        // Passive scroll listener for performance
        window.addEventListener('scroll', onScroll, { passive: true });
    }
})();
